import React, { useState, useEffect } from "react";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

const Documentation = () => {
  const [activeSection, setActiveSection] = useState("introduction");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsSidebarOpen(true); // Always open on desktop
      } else {
        setIsSidebarOpen(false); // Closed by default on mobile
      }
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const sections = [
    { id: "introduction", title: "Introduction" },
    { id: "getting-started", title: "Getting Started" },
    { id: "features", title: "Features" },
    { id: "api", title: "API Reference" },
    { id: "examples", title: "Examples" },
    { id: "faq", title: "FAQ" },
  ];

  return (
    <>
      <Header2 />
      <main className="main" style={{ paddingTop: "2rem" }}>
        <div className="documentation" style={{ 
          display: "flex", 
          width: "88%",
          maxWidth: "88%",
          margin: "0 auto",
          gap: "3rem",
          padding: "0 1% 4rem",
          position: "relative",
          overflow: isMobile ? "visible" : "visible"
        }}>
          {/* Mobile Overlay */}
          {isMobile && isSidebarOpen && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.7)",
                zIndex: 999,
                backdropFilter: "blur(4px)"
              }}
              onClick={() => setIsSidebarOpen(false)}
            />
          )}

          {/* Sidebar Navigation */}
          <aside 
            onClick={isMobile && !isSidebarOpen ? () => setIsSidebarOpen(true) : undefined}
            className={isMobile && !isSidebarOpen ? "sidebar-hover-animation" : ""}
            style={{
              width: "280px",
              position: isMobile ? "fixed" : "sticky",
              top: isMobile ? "6rem" : "2rem",
              left: isMobile ? (isSidebarOpen ? "0" : "-260px") : "auto",
              height: "fit-content",
              maxHeight: isMobile ? "calc(100vh - 8rem)" : "calc(100vh - 4rem)",
              backgroundColor: "rgba(17, 17, 17, 0.95)",
              borderRadius: isMobile ? (isSidebarOpen ? "0 12px 12px 0" : "0 12px 12px 0") : "12px",
              padding: "2rem",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              backdropFilter: "blur(10px)",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
              zIndex: isMobile ? 1000 : "auto",
              transition: isMobile ? "left 0.3s ease-in-out" : "none",
              cursor: isMobile && !isSidebarOpen ? "pointer" : "default"
            }}>
            {(!isMobile || isSidebarOpen) && (
              <>
                <h3 style={{ 
                  marginTop: 0, 
                  marginBottom: "2rem",
                  fontSize: "1.4rem",
                  color: "#d2ff1f",
                  fontWeight: "600"
                }}>
                  Documentation
                </h3>
                <nav>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {sections.map((section) => (
                  <li key={section.id} style={{ marginBottom: "0.75rem" }}>
                    <a
                      href={`#${section.id}`}
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveSection(section.id);
                        const element = document.getElementById(section.id);
                        if (element) {
                          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                          const offsetPosition = elementPosition - 150;
                          window.scrollTo({
                            top: offsetPosition,
                            behavior: "smooth"
                          });
                        }
                        // Close sidebar on mobile after selection
                        if (isMobile) {
                          setIsSidebarOpen(false);
                        }
                      }}
                      style={{
                        display: "block",
                        padding: "0.875rem 1.25rem",
                        color: activeSection === section.id ? "#d2ff1f" : "rgba(255, 255, 255, 0.7)",
                        textDecoration: "none",
                        borderRadius: "8px",
                        backgroundColor: activeSection === section.id ? "rgba(210, 255, 31, 0.15)" : "transparent",
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                        border: activeSection === section.id ? "1px solid rgba(210, 255, 31, 0.4)" : "1px solid transparent",
                        fontWeight: activeSection === section.id ? "500" : "400"
                      }}
                      onMouseEnter={(e) => {
                        if (activeSection !== section.id) {
                          e.target.style.backgroundColor = "rgba(255, 255, 255, 0.05)";
                          e.target.style.color = "rgba(255, 255, 255, 0.9)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (activeSection !== section.id) {
                          e.target.style.backgroundColor = "transparent";
                          e.target.style.color = "rgba(255, 255, 255, 0.7)";
                        }
                      }}
                    >
                      {section.title}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
              </>
            )}
          </aside>

          {/* Main Content Area */}
          <div style={{ 
            flex: 1, 
            minWidth: 0,
            width: isMobile ? "100%" : "auto"
          }}>
            {sections.map((section) => (
              <section
                key={section.id}
                id={section.id}
                style={{
                  marginBottom: "3rem",
                  padding: "3rem",
                  backgroundColor: "rgba(17, 17, 17, 0.9)",
                  borderRadius: "12px",
                  border: "1px solid rgba(255, 255, 255, 0.1)",
                  color: "#fff",
                  lineHeight: "1.7",
                  backdropFilter: "blur(10px)",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)"
                }}
              >
                <h2 style={{
                  fontSize: "2rem",
                  color: "#d2ff1f",
                  marginTop: 0,
                  marginBottom: "2rem",
                  fontWeight: "600"
                }}>
                  {section.title}
                </h2>
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "4rem 2rem",
                  textAlign: "center"
                }}>
                  <div style={{
                    width: "80px",
                    height: "80px",
                    marginBottom: "1.5rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                    backgroundColor: "rgba(210, 255, 31, 0.1)",
                    border: "2px solid rgba(210, 255, 31, 0.3)"
                  }}>
                    <svg 
                      width="40" 
                      height="40" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="#d2ff1f" 
                      strokeWidth="2"
                      style={{ opacity: 0.8 }}
                    >
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                      <line x1="16" y1="13" x2="8" y2="13" />
                      <line x1="16" y1="17" x2="8" y2="17" />
                      <polyline points="10 9 9 9 8 9" />
                    </svg>
                  </div>
                  <div style={{
                    fontSize: "1.5rem",
                    color: "rgba(255, 255, 255, 0.9)",
                    marginBottom: "1rem",
                    fontWeight: "500"
                  }}>
                    Coming Soon
                  </div>
                  <p style={{
                    fontSize: "1rem",
                    color: "rgba(255, 255, 255, 0.6)",
                    maxWidth: "500px",
                    margin: 0,
                    lineHeight: "1.6"
                  }}>
                    This section is currently under development. We're working hard to bring you comprehensive documentation.
                  </p>
                </div>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
      <style>{`
        @keyframes sidebarHover {
          0%, 100% {
            transform: translateX(0);
          }
          50% {
            transform: translateX(8px);
          }
        }
        
        .sidebar-hover-animation {
          animation: sidebarHover 2s ease-in-out infinite;
        }
      `}</style>
    </>
  );
};

export default Documentation;
